import { Capacitor } from '@capacitor/core';

/**
 * Ottiene l'URL base dell'API in base alla piattaforma e all'ambiente
 * @returns string - URL base dell'API
 */
export const getApiUrl = (): string => {
  const isNative = Capacitor.isNativePlatform();
  const platform = Capacitor.getPlatform();

  // Prende l'URL dalle variabili d'ambiente
  let apiUrl = import.meta.env.VITE_API_URL || 'https://localhost:5001/api';

  // Su piattaforme native, non possiamo usare localhost
  if (isNative) {
    // Se l'URL contiene localhost, sostituisci con un URL appropriato
    if (apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1')) {
      console.warn(
        '⚠️ ATTENZIONE: URL API contiene localhost. Su dispositivi mobili devi usare un IP reale o un dominio.'
      );
      console.warn('Configura VITE_API_URL nel file .env con l\'indirizzo IP del tuo server');
      console.warn('Esempio: VITE_API_URL=http://192.168.1.100:5001/api');

      // In development, suggerisci di usare l'IP della macchina
      if (import.meta.env.DEV) {
        console.warn('Per testing locale, trova l\'IP del tuo computer con:');
        console.warn('- Windows: ipconfig');
        console.warn('- macOS/Linux: ifconfig');
      }
    }

    console.log(`📱 Mobile API URL (${platform}): ${apiUrl}`);
  } else {
    console.log(`🌐 Web API URL: ${apiUrl}`);
  }

  return apiUrl;
};

/**
 * Verifica se l'URL dell'API è configurato correttamente per mobile
 * @returns boolean - true se l'URL è valido per mobile
 */
export const isApiUrlValid = (): boolean => {
  const isNative = Capacitor.isNativePlatform();
  const apiUrl = import.meta.env.VITE_API_URL || '';

  // Su web, localhost va bene
  if (!isNative) {
    return true;
  }

  // Su mobile, localhost non funziona
  if (apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1')) {
    return false;
  }

  return true;
};

/**
 * Ottiene l'URL completo per un endpoint specifico
 * @param endpoint - Endpoint dell'API (es: '/auth/login')
 * @returns string - URL completo
 */
export const getFullApiUrl = (endpoint: string): string => {
  const baseUrl = getApiUrl();

  // Rimuovi lo slash iniziale se presente
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;

  // Rimuovi lo slash finale dalla base URL se presente
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

  return `${cleanBaseUrl}/${cleanEndpoint}`;
};

/**
 * Utility per logging dell'URL API durante il development
 */
export const logApiConfiguration = (): void => {
  console.group('🔧 API Configuration');
  console.log('Platform:', Capacitor.getPlatform());
  console.log('Is Native:', Capacitor.isNativePlatform());
  console.log('API URL:', getApiUrl());
  console.log('Environment:', import.meta.env.VITE_ENV || 'development');
  console.log('Valid for mobile:', isApiUrlValid());
  console.groupEnd();
};
